import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  props: ['title'],
  methods: {
    ...mapActions(['back'])
  },
  computed: {
    ...mapState({
      dynamicTitle: (state) => state.toolbar.title,
      processing: (state) => state.toolbar.processing
    }),
    ...mapGetters(['isLoggedIn', 'preRoute']),
    resultTitle () {
      return this.title || this.dynamicTitle
    }
  }
}
